interface PlaceholderTabProps {
    title: string
    description: string
}

export function PlaceholderTab({ title, description }: PlaceholderTabProps) {
    return (
        <div className="p-8 max-w-7xl mx-auto">
            <div className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-2">{title}</h2>
                <p className="text-gray-400">{description}</p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-12 text-center backdrop-blur-sm">
                <div className="text-gray-400 mb-2 font-medium">
                    This feature is currently in development
                </div>
                <div className="text-xs text-gray-500 max-w-sm mx-auto">
                    We're building advanced orquestration layers to ensure maximum stability and performance.
                </div>
            </div>
        </div>
    )
}
